import { render, staticRenderFns } from "./ResizeBox.vue?vue&type=template&id=b49900c4&scoped=true&lang=html&"
import script from "./ResizeBox.vue?vue&type=script&lang=js&"
export * from "./ResizeBox.vue?vue&type=script&lang=js&"
import style0 from "./ResizeBox.vue?vue&type=style&index=0&id=b49900c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49900c4",
  null
  
)

export default component.exports